import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { FilterTag } from 'components/filtertags'
import { OrigemDadoEnumRecord } from 'components/origem-label-tag/OrigemRegistroInfo'
import { useMemoWithDeepCompare } from 'hooks/useMemoWithDeepCompare'
import { useServerTime } from 'hooks/useServerTime'
import { useState } from 'react'
import { humanizeDateRange } from 'util/date/humanize-date'

import { convertAtividadeColetivaFilterFormModelToInput } from '../converter-atividadeColetiva'
import {
  AtividadeColetivaFilterFormModel,
  AtividadeColetivaFonteEnum,
  tipoAtividadeRecord,
} from '../model-atividadeColetiva'

export const useAtividadeColetivaFilter = (isReuniao: boolean) => {
  const { acesso, profissional } = useAcessoLotacaoOrEstagio()

  const equipes = acesso?.equipe ? [acesso.equipe] : []

  const [filter, setFilter] = useState<AtividadeColetivaFilterFormModel>({
    isReuniao,
    fonteRegistros: AtividadeColetivaFonteEnum.PEC,
    equipes,
    pageParams: {
      page: 0,
      size: 10,
      sort: ['-dataAtividade'],
    },
  })

  const convertedFilter = useMemoWithDeepCompare(
    () => convertAtividadeColetivaFilterFormModelToInput(filter, profissional.cns ?? profissional.cpf),
    [profissional, filter]
  )

  const { getServerTimeNow } = useServerTime()
  const tipoAtividadeFilterTag = convertedFilter.tiposAtividade?.map((tipo) => tipoAtividadeRecord[tipo]).join(', ')
  const periodoAtividadeFilterTag = humanizeDateRange(convertedFilter.periodo, getServerTimeNow())
  const equipeFilterTag = convertedFilter.equipesIne
    ? [...new Set(filter.equipes?.map((equipe) => equipe.nome))].join(', ')
    : undefined
  const origemFilterTag = convertedFilter.origens?.map((origem) => OrigemDadoEnumRecord[origem]?.nome).join(', ')
  const processadoFilterTag = convertedFilter.isProcessado && 'Sim'

  const filterTags: FilterTag[] = [
    ['Tipo de atividade', tipoAtividadeFilterTag],
    ['Período da atividade', periodoAtividadeFilterTag],
    ['Equipe', equipeFilterTag],
    ['Origem', origemFilterTag],
    ['Processado', processadoFilterTag],
  ]

  return { filter, setFilter, convertedFilter, filterTags }
}
